<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="profile-post">
                <div class="post-header">
                    <div class="d-flex"><img class="img-thumbnail rounded-circle me-3" src="@/assets/images/user/7.jpg"
                            alt="Generic placeholder image">
                        <div class="flex-grow-1 align-self-center"><router-link to="/app/social-app">
                                <h5 class="user-name">Emay Walter</h5>
                            </router-link>
                            <h6>5 Hours ago</h6>
                        </div>
                    </div>
                    <div class="post-setting"><i class="fa fa-ellipsis-h"></i></div>
                </div>
                <div class="post-body">
                    <div class="img-container">
                        <div class="row mt-4 pictures my-gallery" itemscope="">
                            <figure class="col-sm-6" itemprop="associatedMedia" itemscope=""  v-for="(src, index) in imgs"
                             :key="index" @click="() => showImg(index)"><img class="img-fluid rounded" :src="require('../../../assets/images/user-profile/'+src.image)"  itemprop="thumbnail" alt="Image description">  
                              </figure>
                        </div>
                        <vue-easy-lightbox :index="index" :visible="visible" :imgs="lightBoxImages" @hide="handleHide"></vue-easy-lightbox>
                    </div>
                    <div class="post-react mt-4">
                        <ul>
                            <li><img class="rounded-circle" src="@/assets/images/user/3.jpg" alt=""></li>
                            <li><img class="rounded-circle" src="@/assets/images/user/5.jpg" alt=""></li>
                            <li><img class="rounded-circle" src="@/assets/images/user/1.jpg" alt=""></li>
                        </ul>
                        <h6>+25 people react this post</h6>
                    </div>
                    <p>Success isn't about the end result, it's about what you learn along the way. Confidence. If you have
                        it, you can make anything look good. Grunge is a hippied romantic version of punk. I'm an accomplice
                        to helping women get what they want. Clothes can transform your mood and confidence. I think it's an
                        old fashioned notion that fashion needs to be exclusive to be fashionable.</p>
                    <ul class="post-comment">
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="heart"></vue-feather>&nbsp;&nbsp;Like<span
                                        class="counter">520</span></a></label>
                        </li>
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="message-square"></vue-feather>&nbsp;&nbsp;Comment<span
                                        class="counter">85</span></a></label>
                        </li>
                        <li>
                            <label><a href="javascript:void(0)"><vue-feather
                                        type="share"></vue-feather>&nbsp;&nbsp;share<span
                                        class="counter">30</span></a></label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'post2Page',
    data(){
      return{
         lightBoxImages:[],
            visible: false,
             imgs: [{image:'post2.jpg'}, {image:'post3.jpg'},]
      }
    },
     methods: {
      showImg (index) {
        this.index = index
        this.visible = true
      },
      handleHide () {
        this.visible = false
      },
    },
    mounted(){
        this.imgs.forEach(item=>{
            this.lightBoxImages.push(require('@/assets/images/user-profile/'+item.image))
        })
    }
}
</script>